/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamBulkCreateItemRequestSchema = z.object({
  description: z.string().nullish(),
  memberNames: z.array(z.string()),
  name: z.string().min(1),
});
